// extracted by mini-css-extract-plugin
module.exports = {"successWrapper":"Page_successWrapper__kMR1M","successText":"Page_successText__3k721"};